import { render } from "./paytype.vue?vue&type=template&id=1f879d32&scoped=true"
import script from "./paytype.vue?vue&type=script&lang=js"
export * from "./paytype.vue?vue&type=script&lang=js"

import "./paytype.vue?vue&type=style&index=0&id=1f879d32&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f879d32"]])

export default __exports__